import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CereriService } from './cereri.service';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { environment } from 'src/environments/environment';
import { Observable, Subject, Subscription, catchError, distinctUntilChanged, finalize, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { StatusService } from 'src/app/platform/nomenclatoare/status-cerere/status.service';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { Cerere, UsersByCompartimentePayload } from './cereri.interface';
import { CereriAsigneazaComponent } from './cereri-asigneaza/cereri-asigneaza.component';
import { CereriStatusComponent } from './cereri-status/cereri-status.component';
import { CereriPrioritateComponent } from './cereri-prioritate/cereri-prioritate.component';
import { NotificationService } from 'src/app/services/notification.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { AddCerereComponent } from './add-cerere/add-cerere.component';
import Swal from 'sweetalert2';
import { BreakpointObserver } from '@angular/cdk/layout';
import { PermissionsService } from 'src/app/services/permissions.service';
import { CererePriorityService } from 'src/app/platform/nomenclatoare/cerere-priority/cerere-priority.service';
import { InchidereMultiplaComponent } from './inchidere-multipla/inchidere-multipla.component';

@Component({
    selector: 'app-cereri',
    templateUrl: './cereri.component.html',
    styleUrls: ['./cereri.component.scss'],
})
export class CereriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    checkboxSelections = false;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(2020, 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';
    directii!: any[];
    statusCerere!: any;
    prioritateCerere!: any;
    compartimente!: any;

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Adăugare' },
        { id: 2, value: 'Actualizare' },
        { id: 3, value: 'Validare' },
        { id: 4, value: 'Invalidare/Anulare' },
        { id: 5, value: 'Finalizare' },
    ];

    dateFilterOption: number = 1;

    statusParametersValue!: string;
    categoryParametersValue!: string;
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };

    // Values for status filtering
    parameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    }

    // Value for status filtering
    selectedStatusID: string | number = 2; // ar trebui schimbata sa se ia statusul din loadRequestsStatuses (vezi linia 403)

    // Values for category filtering
    categoryToggleOptions = [
        { id: 3, value: 'Toate' },
        { id: 2, value: 'Departamentele mele' },
        { id: 1, value: 'Cererile mele' },
        { id: 4, value: 'Mesaje interne' },
    ];

    selectedCategory: string | number = 1;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    requestTypes$!: Observable<Generic[]>;
    requestStatuses$!: Observable<Generic[]>;
    departamente$: any[] = [];
    tipuri$!: Generic[];
    users$!: Generic[];

    statusParameters: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Validată', value: 1 },
        { key: 'Invalidată', value: 2 },
        { key: 'Anulată', value: 3 },
        { key: 'Necesită atenție', value: 4 },
    ];

    sourceParameters: any[] = [];

    responsabilCerereParameters: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Fără responsabil', value: 2 },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    private destroy$ = new Subject<void>();

    // Filtered fields for search
    filteredCategorii!: any[];
    categoriiControl = new FormControl();

    filteredTipuriProblema: any[] = [];
    tipuriProblemaControl = new FormControl();

    filteredUsers: any[] = [];
    usersControl = new FormControl();

    filteredCategoriiCurent!: any[];
    categoriiCurentControl = new FormControl();

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        id_category: -1,
        id_cerere_type: -1,
        reg_numar: '',
        id_cerere: '',
        nume_cetatean: '',
        cnp_cetatean: '',
        email_cetatean: '',
        validated: -1,
        current_cerere_id_compartiment: -1,
        responsible_id: -1,
        assignee_id: -1,
        serie_sasiu: '',
        marca: '',
        source: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            id_category: new FormControl(-1),
            id_cerere_type: new FormControl(-1),
            reg_numar: new FormControl(''),
            id_cerere: new FormControl(''),
            nume_cetatean: new FormControl(''),
            cnp_cetatean: new FormControl(''),
            email_cetatean: new FormControl(''),
            validated: new FormControl(-1),
            current_cerere_id_compartiment: new FormControl(-1),
            responsible_id: new FormControl(-1),
            assignee_id: new FormControl(-1),
            serie_sasiu: new FormControl(''),
            marca: new FormControl(''),
            source: new FormControl(-1),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.loadTipuri(-1);
        this.loadUsers(-1);

        this.filteredCategorii = this.departamente$;
        this.categoriiControl.setValue(null);

        this.tipuriProblemaControl.setValue(null);

        this.usersControl.setValue(null);

        this.filteredCategoriiCurent = this.departamente$;
        this.categoriiCurentControl.setValue(null);

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch()

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    loadRequestTypes() {
        this.requestTypes$ = this.cereriService
            .getRequestTypes()
            .pipe(map((results: any) => [this.defaultParameter, ...results]));
    }

    // Info for conditional assign and change status from DT

    selectedRowIds: number[] = [];

    rowCount = 0;

    dtLink =
        environment.interop.basePath +
        environment.interop.dgitl.cerere.getCereriDT;

    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private cereriService: CereriService,
        private commonService: CommonService,
        private cerereStatusService: StatusService,
        private cererePriorityService: CererePriorityService,
        private notificationService: NotificationService,
        private router: Router,
        private breakpointObserver: BreakpointObserver,
        public permissionsService: PermissionsService,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.loadRequestStatuses();
        this.loadRequestPriorities();
        this.renderDT();
        this.loadDepartamente();
        this.loadDirectii();
        this.loadSources();
        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        this.loadRequestTypes();
        this.redirectFromNotifications();
        this.filterCategoryOptions();
        this.renderFieldsSearch();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();

        this.destroy$.next();
        this.destroy$.complete();
    }

    redirectFromNotifications() {
        this.notificationService.currentNotification.subscribe(
            (notification: { id: string; name: string }) => {
                if (notification) {
                    this.notificationParameter = notification;
                    // here we need to update our buttons
                    this.notificationServiceBefore.currentStatus = this.selectedStatusID;
                    this.notificationServiceBefore.currentCategory = this.selectedCategory;

                    this.selectedStatusID = 2;
                    this.selectedCategory = 1;

                    this.rerenderDT();
                }
            }
        );
    }

    removeChip(): void {
        // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
        this.notificationParameter = { id: '-1', name: '' };

        // here we need to update our buttons
        this.selectedStatusID = this.notificationServiceBefore.currentStatus;
        this.selectedCategory = this.notificationServiceBefore.currentCategory;

        this.rerenderDT();
    }

    loadSources() {
        this.isLoading = true;
        this.cereriService.getSources()
            .pipe(finalize(() => this.isLoading = false))
            .subscribe({
                next: (results: any) => {
                    this.sourceParameters = [this.defaultParameter, ...results];
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isFilterLoading = false;
                },
            })
    }

    loadDirectii() {
        this.cereriService.getCompartimente()
            .subscribe({
                next: (res: any) => {
                    let response = (typeof res.status_code !== 'undefined' ? res : res.error)
                    if (typeof response.status_code !== 'undefined') {
                        if (response.status_code == 200 && typeof response.data !== 'undefined') {
                            this.directii = response.data;
                            this.isLoading = false;
                            return;
                        }
                    } else {
                        let errorMessage = environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(environment.config.customNotifications.headers.error, errorMessage, environment.config.customNotifications.icons.error);
                    }
                },
                error: (err: any) => {
                    console.log(err.error);
                }
            })
    }

    loadDepartamente() {
        this.isFilterLoading = true;
        this.cereriService.getCompartimenteByAccess()
            .pipe(
                finalize(() => this.isFilterLoading = false)
            )
            .subscribe({
                next: (res: any) => {
                    let response = (typeof res.status_code !== 'undefined' ? res : res.error)
                    if (typeof response.status_code !== 'undefined') {
                        if (response.status_code == 200 && typeof response.data !== 'undefined') {
                            this.departamente$ = response.data;
                            this.filteredCategorii = [...this.departamente$];
                            this.filteredCategoriiCurent = [...this.departamente$];
                            return;
                        }
                    } else {
                        let errorMessage = environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(environment.config.customNotifications.headers.error, errorMessage, environment.config.customNotifications.icons.error);
                    }
                },
                error: (err: any) => {
                    console.log(err.error);
                }
            })
    }

    renderFieldsSearch() {
        this.categoriiControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCategorii = this.departamente$;
                    return of(this.departamente$);
                }
                return this.filterCategorii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCategorii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.tipuriProblemaControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredTipuriProblema = this.tipuri$;
                    return of(this.tipuri$);
                }
                return this.filterTipuri(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredTipuriProblema = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.usersControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredUsers = this.users$;
                    return of(this.users$);
                }
                return this.filterUsers(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredUsers = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.categoriiCurentControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCategoriiCurent = this.departamente$;
                    return of(this.departamente$);
                }
                return this.filterCategorii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCategoriiCurent = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        // return value.toLowerCase();
    }

    filterCategorii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.departamente$.filter(categorie =>
            this.normalizeString(categorie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onDepartamentSelectClosed() {
        const selectedValue = this.categoriiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCategorii.some(categorie =>
                categorie.id_compartiment === this.searchParamsForm.get('id_category')?.value
            );

            if (!isSelectedInFilteredList) {
                this.categoriiControl.setValue(null);
                this.filteredCategorii = this.departamente$;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDepartamentChange(departamentId: number): void {
        this.searchParamsForm.controls['id_cerere_type'].patchValue(-1);

        if (departamentId == -1) {
            this.tipuri$ = [];
            this.filteredTipuriProblema = [];
            return;
        }

        if (departamentId) {
            this.loadTipuri(departamentId);
        }
    }

    loadTipuri(departamentId?: number) {
        this.isFilterLoading = true;

        let tipuriObservable$ = departamentId
            ? this.cereriService.getTipuriByDepartamenteId(departamentId)
            : this.commonService.getCompartimenteActive();

        tipuriObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        ).subscribe({
            next: (tipuri) => {
                this.filteredTipuriProblema = [...tipuri];
                this.tipuri$ = [...tipuri];
            },
            error: (err) => {
                console.log(err.error);
                this.filteredTipuriProblema = [];
            }
        });

    }

    onTipSelectClosed() {
        const selectedValue = this.tipuriProblemaControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredTipuriProblema.some(tip =>
                tip.id === this.searchParamsForm.get('id_cerere_type')?.value
            );

            if (!isSelectedInFilteredList) {
                this.tipuriProblemaControl.setValue(null);
                this.filteredTipuriProblema = this.tipuri$;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    filterTipuri(searchTerm: string): Observable<Generic[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        return of(this.tipuri$.filter(tip =>
            this.normalizeString(tip.name).includes(normalizedSearchTerm)
        ));
    }

    onCategorieCurentSelectClosed() {
        const selectedValue = this.categoriiCurentControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCategoriiCurent.some(categorie =>
                categorie.id_compartiment === this.searchParamsForm.get('current_cerere_id_compartiment')?.value
            );

            if (!isSelectedInFilteredList) {
                this.categoriiCurentControl.setValue(null);
                this.filteredCategoriiCurent = this.departamente$;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onCategorieCurentChange(departamentId: number): void {
        this.searchParamsForm.controls['responsible_id'].patchValue(-1);

        if (departamentId == -1) {
            this.users$ = [];
            this.filteredUsers = [];
            return;
        }

        if (departamentId) {
            this.loadUsers(departamentId);
        }
    }

    onUsersSelectClosed() {
        const selectedValue = this.usersControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredUsers.some(user =>
                user.id === this.searchParamsForm.get('responsible_id')?.value
            );

            if (!isSelectedInFilteredList) {
                this.usersControl.setValue(null);
                this.filteredUsers = this.users$;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    loadUsers(departamentId: number) {
        this.isFilterLoading = true;
        let payload: UsersByCompartimentePayload = { compartiment_id: departamentId };

        let usersObservable$ = departamentId
            ? this.cereriService.getActiveUsersByCompartiment(payload)
            : this.commonService.getUsersActive();

        usersObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        ).subscribe({
            next: (users) => {
                this.filteredUsers = [...users];
                this.users$ = [...users];
            },
            error: (err) => {
                console.log(err.error);
                this.filteredUsers = [];
            }
        });
    }

    filterUsers(searchTerm: string): Observable<Generic[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        return of(this.users$.filter(user =>
            this.normalizeString(user.name).includes(normalizedSearchTerm)
        ));
    }

    loadRequestStatuses() {
        this.isFilterLoading = true;
        this.cerereStatusService
            .getStatuses()
            .pipe(
                map((results: any) => [...results, this.parameter]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusCerere = results;
                    let status = this.statusCerere.find((statusCerere: any) => statusCerere.slug === 'deschis');
                    this.selectedStatusID = status ? status.id : this.parameter.id;
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                },
            });
    }

    loadRequestPriorities() {
        this.cererePriorityService
            .getCererePriorities()
            .pipe(map((results: any) => [this.parameter, ...results]))
            .subscribe((data: any) => {
                this.prioritateCerere = data;
            });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 50,
            order: [[1, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.id_cerere_status = this.selectedStatusID;
                dataTablesParameters.id_cerere_priority = this.selectedCategory;
                dataTablesParameters.filters = this.searchParamsForm.value;
                dataTablesParameters.dateFilter = +this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(this.selectedStartDate);
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                dataTablesParameters.notificationParameter = this.notificationParameter.id;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });

                        if (resp.data.recordsFiltered < dataTablesParameters.start) {
                            this.rerenderDT(true);  // sets dataTablesParameters.start = 0, goes to page 1
                        }
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '5%', targets: 0 },
                { width: '10%', targets: 1 },
                { width: '25%', targets: 2 },
                { width: '15%', targets: 3 },
                { width: '15%', targets: 4 },
                { width: '12%', targets: 5 },
                { width: '18%', targets: 6 },
            ],

            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'id_cerere',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id_cerere}" />`
                    }
                },
                {
                    title: 'ID',
                    data: 'id_cerere',
                    render: (data: any, type: any, row: any) => {
                        let source = row.source_data.name.toUpperCase();
                        let color = row.source_data.color;
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';

                        return `
							<div>
                                <span>R: ${row.reg_numar ? row.reg_numar : 'N/A'}</span>
                                <span>/</span>
                                <span>${row.reg_date}</span>
							</div>
							<div> <br/>
                                <span style="padding: 3px 6px; background-color: #bdbdbd; border: 0px;border-radius:10px">I: ${row.id_cerere}</span>
                                <span style="color: ${color}; font-weight: 700;">&nbsp${source}</span>
							</div>

                            ` + (row.mesajeInterne == 1 ?
                                `<div> <br/><span  style="padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">${flagIcon} Mesaj intern</span>
                                    </div>`
                                : '')
                            + `
						`;
                    },
                },
                {
                    title: 'Tip Cerere',
                    data: 'subject',
                    orderable: true,
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';

                        return `
							<span>` + (row.user_assigned_name === 'n/a' ? `<strong>${row.subject}</strong>` : `${row.subject}`) + `</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px"> Categorie / Tip</span><br/>
							<span>
                                <img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
                                <span style="font-weight: normal;">${row.compartiment_denumire}</span> <br/>
                                <img src="${imageTreeUrl}" alt="Image" style="width: 20px; height: 20px;">
                                <span style="font-weight: normal;">${row.type}</span>
                            </span><br/><br/>
						`;
                    },
                },
                {
                    title: 'Identificare',
                    data: 'user_submit_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const userUrl = '/assets/icons/icon-user.svg';
                        const societateUrl = '/assets/icons/companii.svg';
                        let societate;
                        if (row.denumire !== null) {
                            societate = `
                                        <img class="me-1" src="${societateUrl}" alt="Image" style="width: 20px; height: 20px;">
                                        <span>${row.denumire}</span>
                                        `;
                        } else {
                            societate = '';
                        }
                        return `
						<span style="color:#bdbdbd; font-size:12px"> Cetățean/Societate</span><br/>
						<img src="${userUrl}" alt="Image" style="width: 20px; height: 20px;">
						<span>${row.user_submit_name}</span> <br/>
                        ${societate}
                        `;
                    },
                },
                {
                    title: 'Atribuire',
                    data: 'user_assigned_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <span style="color:#bdbdbd; font-size:12px">Serviciu/Birou/Departament</span><br/>
                            <span>${row.compartiment_denumire_assigned || 'n/a'}</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Operator Asignat</span><br/>
							<span>${row.user_assigned_name}</span>
						`;
                    },
                },
                {
                    title: 'Prioritate',
                    data: 'sla',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
							<span style="border-radius:10px; padding:4px 8px; color: ${row.priority_color}; background: ${row.priority_color}">${row.priority}</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px">SLA</span><br/>
							<span>${row.sla}</span><br/>
						`;
                    },
                },
                {
                    title: 'Status',
                    data: 'updated_at',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let label = '';
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        if (row.validated_date && !row.cancel_date) {
                            // Validat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: green">${flagIcon}Validat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 1) {
                            // Invalidat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: orange">${flagIcon}Invalidat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 2) {
                            // Clasat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: red">${flagIcon}Clasat</span>`;
                        } else {
                            // Default case
                            label = ``;
                        }
                        return `
							<span style="border-radius:10px; padding:4px 8px; color: ${row.status_color}; background: ${row.status_color}">${row.status.replace(/<span\s+class="pull-right[^>]+>[^<]+<\/span>/, '')}</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px">Ultima actualizare</span><br/>
							<span>${row.updated_at}</span><br/>
                            <br/>${label}
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');
                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idCerere = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idCerere);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idCerere
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: Cerere) => {
                            self.selectedRowIds.push(item.id_cerere);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        };
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }

    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }

    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    onRowClick(rowData: Request) {
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });

        this.closePopover();
    }

    openInfoDialog(data: any) {
        const dialogRef = this.dialog.open(CereriDetaliiComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                cerere: data,
                directii: this.directii,
                statusCerere: this.statusCerere,
                prioritateCerere: this.prioritateCerere,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
            this.destroy$.next();
            this.destroy$.complete();
            this.renderFieldsSearch();
        });
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.selectedStatusID = event.value;

        this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.selectedCategory = event.value;

        const selectedOption = this.categoryToggleOptions.find(option => option.id === event.value);
        this.categoryParametersValue = selectedOption ? selectedOption.value : 'default';
    }

    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "3": "dgitl-module.cerere.list-all",
            "2": "dgitl-module.cerere.list-my-departments",
            "1": "dgitl-module.cerere.list-my-requests",
            "4": "dgitl-module.cerere.list-intern-messages",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedCategory = 1;
    }

    onDateFilterChange(): void {
        // this.rerenderDT();
    }

    openReassignComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriAsigneazaComponent, {
                ...this.dialogService.getDialogConfig(),
                data: {
                    selectedRowIds: this.selectedRowIds,
                    directii: this.directii
                }
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openChangeStatusComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriStatusComponent, {
                ...this.dialogService.getDialogConfig(),
                data: {
                    selectedRowIds: this.selectedRowIds,
                    statusCerere: this.statusCerere,
                }
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openChangePrioritateComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriPrioritateComponent, {
                ...this.dialogService.getDialogConfig(),
                data: {
                    selectedRowIds: this.selectedRowIds,
                    prioritateCerere: this.prioritateCerere,
                }
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openInchidereMultiplaComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(InchidereMultiplaComponent, {
                ...this.dialogService.getDialogConfig(),
                data: {
                    selectedRowIds: this.selectedRowIds,
                }
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    redirectTo(): void {
        const slug = 'someString';
        this.router.navigate([slug]);
    }

    openAddDialog() {
        let configData = {
            width: '80%',
            height: '70%',
            minWidth: '275px',
        };

        const dialogRef = this.dialog.open(AddCerereComponent, configData);

        const layoutChanges = this.breakpointObserver.observe([
            '(max-width: 599px)', // xs breakpoint
            '(min-width: 600px)'  // sm breakpoint
        ]);

        const layoutChangeSubscription = layoutChanges.subscribe(result => {
            if (result.matches) {
                if (result.breakpoints['(max-width: 599px)']) {
                    // Smaller devices          
                    dialogRef.updateSize('95%', '80%')
                } else {
                    // Larger devices
                    dialogRef.updateSize('40%', '78%')
                }
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Cerere adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
            layoutChangeSubscription.unsubscribe();
        });
    }
}
